import styled from 'styled-components';
import { color, container, screen, spacing } from '../../../theme';

export const StyledContainer = styled.div`
  background-color: ${color('sand_100')};
  padding-top: ${spacing('xl3')};
  padding-bottom: ${spacing('xl3')};

  @media (min-width: ${screen('lg')}) {
    padding-top: ${spacing('xl4')};
    padding-bottom: ${spacing('xl4')};
  }
  margin: auto;
  max-width: calc(${container('md')} + ${spacing('md')} * 2);
  padding-left: ${spacing('md')};
  padding-right: ${spacing('md')};
  text-align: center;
`;

export const StyledNews = styled.dl`
  margin: ${spacing('xl4')} auto;
  max-width: ${container('md')};
  border-bottom: 1px solid ${color('midnight_200')};
  counter-reset: faqs;
  text-align: left;
`;
